"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReceiveDate = exports.parseExamDate = exports.excludeExamsByDeliveryFormat = exports.filterExamBlocks = exports.filterUpcomingExamBookings = exports.parseExemptionName = exports.parseCurrentExamExemptionBySubjectKey = exports.parseExamProgressStatus = exports.parseExamResultCompletionDate = exports.calculateExamCredits = exports.sortQualificationLevel = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
// TODO: add unit test for this file
const sortQualificationLevel = (qualificationLevels, pathway, isPathwaySwitched = false) => {
    const pathwayQualifications = qualificationLevels.filter(item => { var _a, _b, _c; return (_c = (_b = (_a = item.blocks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.pathway.split(';')) === null || _c === void 0 ? void 0 : _c.includes(pathway); });
    const noPreviousLevel = pathwayQualifications.find(item => item.prevLevel === '');
    const notExistingPreviousLevel = pathwayQualifications.find(item => !pathwayQualifications.some(level => level.name === item.prevLevel));
    const firstLevel = noPreviousLevel ? noPreviousLevel : notExistingPreviousLevel;
    const sortedQualificationLevels = [firstLevel];
    let currentLevels = [firstLevel];
    let loopCount = 0;
    while (sortedQualificationLevels.length !== pathwayQualifications.length) {
        if (loopCount > pathwayQualifications.length)
            break;
        let nextLevels = pathwayQualifications.filter(level => currentLevels.find(item => (item === null || item === void 0 ? void 0 : item.name) === level.prevLevel));
        if (nextLevels.length === 0 && loopCount !== 0) {
            nextLevels = [notExistingPreviousLevel];
        }
        sortedQualificationLevels.push(...nextLevels);
        currentLevels = nextLevels;
        loopCount = loopCount + 1;
    }
    sortedQualificationLevels.map(qualificationLevel => {
        if (qualificationLevel.status === mxp_schemas_1.User.QualificationLevelStatus.Locked) {
            qualificationLevel.blocks.map(level => {
                level.status = mxp_schemas_1.User.SubjectBlockStatus.Locked;
            });
        }
    });
    // Will add EPA 4 if user switched to l7
    // For badge display
    if (isPathwaySwitched) {
        const epa4Qualification = qualificationLevels.find(level => level.name === mxp_schemas_1.MembershipTypes.CimaQualificationLevelPathValue.EPA4);
        sortedQualificationLevels.push(epa4Qualification);
    }
    return sortedQualificationLevels;
};
exports.sortQualificationLevel = sortQualificationLevel;
const calculateExamCredits = (examCredits) => {
    const usedExamAvailable = (examCredits || []).filter((examCredit) => examCredit.SFS_ECR_Status__c === mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Available).length;
    const usedExamCredits = (examCredits || []).filter((examCredit) => [mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Used].includes(examCredit.SFS_ECR_Status__c)).length;
    return { usedExamCredits, usedExamAvailable };
};
exports.calculateExamCredits = calculateExamCredits;
const parseExamResultCompletionDate = (cimaExamResult) => {
    var _a;
    const cimaResultStatus = cimaExamResult ? cimaExamResult.SFS_EXR_Status__c : null;
    const appointmentTimeZone = cimaExamResult
        ? (_a = cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.SFS_EXR_ExamBookingKey__r) === null || _a === void 0 ? void 0 : _a.SFS_EXB_ApptDisplayTZ__c
        : null;
    let completionDate = '';
    if (cimaExamResult) {
        if (cimaExamResult.SFS_EXR_RatificationStatus__c === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.ratified &&
            cimaResultStatus === mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.Pass) {
            completionDate = appointmentTimeZone
                ? moment_timezone_1.default.tz(cimaExamResult.SFS_EXR_DateOfExam__c, appointmentTimeZone).format('MM/DD/YYYY [at] h:mm A')
                : (0, moment_timezone_1.default)(cimaExamResult.SFS_EXR_DateOfExam__c).format('MM/DD/YYYY [at] h:mm A');
        }
    }
    return completionDate;
};
exports.parseExamResultCompletionDate = parseExamResultCompletionDate;
const parseExamProgressStatus = (cimaExamResult) => {
    var _a, _b;
    const cimaResultStatus = cimaExamResult ? cimaExamResult.SFS_EXR_Status__c : null;
    let resultStatus = null;
    let examCardStatus = null;
    if (cimaExamResult) {
        if (cimaExamResult.SFS_EXR_RatificationStatus__c === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.ratified) {
            if (cimaResultStatus === mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.Pass) {
                resultStatus = mxp_schemas_1.User.ResultStatus.Complete;
                examCardStatus = mxp_schemas_1.User.SubjectBlockStatus.Completed;
            }
        }
        if (cimaResultStatus === mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.Fail) {
            resultStatus = mxp_schemas_1.User.ResultStatus.Failed;
            examCardStatus = mxp_schemas_1.User.SubjectBlockStatus.Bookable;
        }
        if (cimaResultStatus === mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.Pending) {
            resultStatus = mxp_schemas_1.User.ResultStatus.Pending;
            // for EPA2 consider as completed to show result in pending!
            examCardStatus =
                ((_a = cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.RecordType) === null || _a === void 0 ? void 0 : _a.Name) === 'EPA2'
                    ? mxp_schemas_1.User.SubjectBlockStatus.Completed
                    : mxp_schemas_1.User.SubjectBlockStatus.Bookable;
        }
        if ([mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.NoShow, mxp_schemas_1.SalesforceResponses.ExamCimaResultStatus.NdaRefuse].includes(cimaResultStatus)) {
            resultStatus = mxp_schemas_1.User.ResultStatus.InProgress;
            examCardStatus = mxp_schemas_1.User.SubjectBlockStatus.Bookable;
        }
        if (cimaExamResult.SFS_EXR_RatificationStatus__c === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.pendingRatification ||
            cimaExamResult.SFS_EXR_RatificationStatus__c === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.onHold) {
            resultStatus = mxp_schemas_1.User.ResultStatus.Pending;
            examCardStatus =
                ((_b = cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.RecordType) === null || _b === void 0 ? void 0 : _b.Name) === 'EPA2'
                    ? mxp_schemas_1.User.SubjectBlockStatus.Completed
                    : mxp_schemas_1.User.SubjectBlockStatus.Bookable;
        }
    }
    return { resultStatus, examCardStatus };
};
exports.parseExamProgressStatus = parseExamProgressStatus;
const parseCurrentExamExemptionBySubjectKey = (exemptions = []) => {
    return exemptions.reduce((prevExemption, currExemption) => {
        if (prevExemption.length === 0)
            return [currExemption];
        return prevExemption.some(exempt => exempt.SFS_PEE_SubjectKey__c === currExemption.SFS_PEE_SubjectKey__c)
            ? prevExemption
            : [...prevExemption, currExemption];
    }, []);
};
exports.parseCurrentExamExemptionBySubjectKey = parseCurrentExamExemptionBySubjectKey;
const parseExemptionName = (recordType) => {
    switch (recordType) {
        case mxp_schemas_1.Salesforce.ExemptionRecordType.EDUCATIONAL_QUALIFICATION:
            return 'Education';
        case mxp_schemas_1.Salesforce.ExemptionRecordType.PROFESSIONAL_QUALIFICATION:
            return 'Professional Qualification';
        case mxp_schemas_1.Salesforce.ExemptionRecordType.WORK_EXPERIENCE:
            return 'Work Experience';
        default:
            return '';
    }
};
exports.parseExemptionName = parseExemptionName;
const filterUpcomingExamBookings = (activeExamBookings) => {
    const nearestUpcomingExam = activeExamBookings.reduce((accumulatedExam, nextExam) => {
        if (!!accumulatedExam) {
            return [
                ...accumulatedExam,
                ...((0, moment_timezone_1.default)(accumulatedExam[0].SFS_EXB_Exam_Schedule_date__c, 'DD/MM/YYYY hh:mm').isSame((0, moment_timezone_1.default)(nextExam.SFS_EXB_Exam_Schedule_date__c, 'DD/MM/YYYY hh:mm'), 'day')
                    ? [nextExam]
                    : []),
            ];
        }
        return [nextExam];
    }, null) || [];
    return nearestUpcomingExam.map((exam) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const examObject = (exam === null || exam === void 0 ? void 0 : exam.SFS_EXB_ExamKey__r) || null;
        return {
            id: (_a = examObject === null || examObject === void 0 ? void 0 : examObject.Id) !== null && _a !== void 0 ? _a : '',
            name: (_b = examObject === null || examObject === void 0 ? void 0 : examObject.Name) !== null && _b !== void 0 ? _b : '',
            status: mxp_schemas_1.User.SubjectBlockStatus.Bookable,
            pathway: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_LearningPathway__c) || '',
            qualificationlevel: (_e = (_d = (_c = examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_SubjectKey__r) === null || _c === void 0 ? void 0 : _c.SFS_SBJ_QualificationLevelKey__r) === null || _d === void 0 ? void 0 : _d.Name) !== null && _e !== void 0 ? _e : '',
            usedExamCredits: 0,
            usedExamAvailable: 0,
            resultStatus: null,
            ratificationStatus: '',
            pvExamSeriesCode: examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_PvExamSeriesCode__c,
            flpCompetencyId: '',
            completionDate: '',
            examExemptionId: '',
            isNonWaivable: false,
            onVueExamKey: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_ExamKey__c) || '',
            freeResit: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_FreeResitFlag__c) || false,
            deliveryFormat: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_ExamDeliveryFormat__c) || null,
            examRecordType: (examObject === null || examObject === void 0 ? void 0 : examObject.RecordType.DeveloperName) || mxp_schemas_1.Salesforce.ExamRecordType.PearsonVue,
            examUrlSlug: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_ExamUrlSlug__c) || null,
            type: (examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_ExamType__c) || mxp_schemas_1.User.SubjectBlockType.ObjectiveTest,
            productId: (_h = (_g = (_f = examObject === null || examObject === void 0 ? void 0 : examObject.SFS_EXM_SubjectKey__r) === null || _f === void 0 ? void 0 : _f.SFS_SBJ_ProductExamCreditKey__r) === null || _g === void 0 ? void 0 : _g.RV_SKUExternalID__c) !== null && _h !== void 0 ? _h : '',
            appointmentDetails: {
                id: exam.Id,
                examDateTime: exam.SFS_EXB_ExamDate__c,
                examScheduleText: exam.SFS_EXB_Exam_Schedule_date__c,
                pvBookingId: exam.SFS_EXB_PvBookingId__c,
                appointmentTimeZone: exam.SFS_EXB_ApptDisplayTZ__c,
                deliveryFormat: exam.SFS_EXB_ExamDeliveryFormat__c === mxp_schemas_1.User.ExamDeliveryFormat.OnlineExam
                    ? mxp_schemas_1.User.ExamDeliveryFormat.OnlineExam
                    : exam.SFS_EXB_ExamDeliveryFormat__c === mxp_schemas_1.User.ExamDeliveryFormat.TestCenter
                        ? mxp_schemas_1.User.ExamDeliveryFormat.TestCenter
                        : null,
                testCenterAddress: {
                    company: exam.SFS_EXB_TestCenterName__c,
                    addressLine1: exam.SFS_EXB_TCLine1__c,
                    addressLine2: exam.SFS_EXB_TCLine2__c,
                    city: exam.SFS_EXB_TCCity__c,
                    state: exam.SFS_EXB_TCState__c,
                    zipCode: exam.SFS_EXB_TCPostalCode__c,
                    country: exam.SFS_EXB_TCCountry__c,
                },
            },
        };
    });
};
exports.filterUpcomingExamBookings = filterUpcomingExamBookings;
const filterExamBlocks = (exams, learningPathway) => exams.filter((exam) => {
    const recordTypesAllowed = [];
    if ([mxp_schemas_1.MembershipTypes.Pathway.PQ, mxp_schemas_1.MembershipTypes.Pathway.CHINESE_PQ].includes(learningPathway)) {
        recordTypesAllowed.push(mxp_schemas_1.Salesforce.ExamRecordType.PearsonVue);
    }
    else if (learningPathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4 ||
        learningPathway === mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7) {
        recordTypesAllowed.push(mxp_schemas_1.Salesforce.ExamRecordType.EPA2);
        recordTypesAllowed.push(mxp_schemas_1.Salesforce.ExamRecordType.PearsonVue);
    }
    else {
        recordTypesAllowed.push(mxp_schemas_1.Salesforce.ExamRecordType.PearsonVue);
        recordTypesAllowed.push(mxp_schemas_1.Salesforce.ExamRecordType.FLPCompetencyGroup);
    }
    return (((exam === null || exam === void 0 ? void 0 : exam.pathway) || '').includes(learningPathway) &&
        recordTypesAllowed.some((recordType) => recordType === exam.examRecordType));
});
exports.filterExamBlocks = filterExamBlocks;
const excludeExamsByDeliveryFormat = (exams, deliveryFormat) => exams.filter((exam) => exam.deliveryFormat !== deliveryFormat);
exports.excludeExamsByDeliveryFormat = excludeExamsByDeliveryFormat;
const parseExamDate = (cimaExamResult, forExamHistory = false) => {
    var _a, _b;
    const examDateString = (cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.SFS_EXR_DateOfExam__c) ? cimaExamResult.SFS_EXR_DateOfExam__c : null;
    const examDateTimeZone = ((_a = cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.SFS_EXR_ExamBookingKey__r) === null || _a === void 0 ? void 0 : _a.SFS_EXB_ApptDisplayTZ__c)
        ? (_b = cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.SFS_EXR_ExamBookingKey__r) === null || _b === void 0 ? void 0 : _b.SFS_EXB_ApptDisplayTZ__c
        : null;
    let examDate = '';
    if (examDateString) {
        const formatString = forExamHistory ? 'D MMMM, YYYY dddd' : 'dddd, MMMM D, YYYY [at] h:mm A';
        examDate = examDateTimeZone
            ? moment_timezone_1.default.tz(examDateString, examDateTimeZone).format(formatString)
            : (0, moment_timezone_1.default)(examDateString).format(formatString);
    }
    return examDate;
};
exports.parseExamDate = parseExamDate;
const parseReceiveDate = (cimaExamResult) => {
    const examDateString = (cimaExamResult === null || cimaExamResult === void 0 ? void 0 : cimaExamResult.SFS_EXR_ResultReceivedDate__c)
        ? cimaExamResult.SFS_EXR_ResultReceivedDate__c
        : null;
    let examDate = '';
    if (examDateString) {
        examDate = (0, moment_timezone_1.default)(examDateString).format('dddd, MMMM D, YYYY');
    }
    return examDate;
};
exports.parseReceiveDate = parseReceiveDate;
//# sourceMappingURL=cimaExamHelpers.js.map